const LOGIN = 'nibi_business/auth/LOGIN';
const LOGOUT = 'nibi_business/auth/LOGOUT';
const SET_USER = 'nibi_business/auth/SET_USER';
const SET_USER_ID = 'nibi_business/auth/SET_USER_ID';
const SET_TOKEN = 'nibi_business/auth/SET_TOKEN';
const SET_CHAT_NOTIFICATION = 'nibi_business/auth/SET_CHAT_NOTIFICATION';
const SET_UPDATE_USER_INFO = 'nibi_business/auth/SET_UPDATE_USER_INFO';

const initialState = {
  authenticated: false,
  user: {},
  userId: '',
  token: '',
  chatNotification: false,
  updateUserInfo: false
};

export default function reducer(state = initialState, action) {

  const payload = action.payload;

  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        authenticated: true,
        user: payload.user,
        userId: payload.userId,
        token: payload.token
      };
    case LOGOUT:
      return initialState;
    case SET_USER:
      return {
        ...state,
        user: payload.user
      };
    case SET_USER_ID:
      return {
        ...state,
        userId: payload.userId
      };
    case SET_TOKEN:
      return {
        ...state,
        token: payload.token
      };
    case SET_CHAT_NOTIFICATION:
      return {
        ...state,
        chatNotification: payload
      };
    case SET_UPDATE_USER_INFO:
      return {
        ...state,
        updateUserInfo: payload.update
      };
    default:
      return state;
  }
}

export function userLogin(payload) {
  return { type: LOGIN, payload };
}

export function userLogout() {
  return { type: LOGOUT };
}

export function setUser(payload) {
  return { type: SET_USER, payload };
}

export function setUserId(payload) {
  return { type: SET_USER_ID, payload };
}

export function setToken(payload) {
  return { type: SET_TOKEN, payload };
}

export function setUpdateUserInfo(payload) {
  return { type: SET_UPDATE_USER_INFO, payload };
}
